import React from 'react';
import { Trophy, Zap, Package, DollarSign, MapPin, Shield } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    icon: <Trophy className="w-10 h-10 text-alphaGold" data-id="element-51" />,
    title: 'Marcas Certificadas',
    desc: 'Las marcas con las que trabajamos garantizan calidad en cada producto. Ingredientes puros, fórmulas probadas, resultados reales.'
  }, {
    icon: <Zap className="w-10 h-10 text-alphaGold" data-id="element-52" />,
    title: 'Atención Inmediata',
    desc: 'Respondemos por WhatsApp al instante. Sin bots, sin demoras. Persona real que entiende tus objetivos.'
  }, {
    icon: <Package className="w-10 h-10 text-alphaGold" data-id="element-53" />,
    title: 'Envíos Rápidos',
    desc: 'Entregamos en Montevideo a las mejores tarifas del mercado. Envío desde $190 UY.'
  }, {
    icon: <DollarSign className="w-10 h-10 text-alphaGold" data-id="element-54" />,
    title: 'Mejor Precio',
    desc: '20% OFF hace que los mejores suplementos estén al alcance de todos. Sin excusas para no empezar.'
  }, {
    icon: <MapPin className="w-10 h-10 text-alphaGold" data-id="element-55" />,
    title: 'Pick Up',
    desc: 'Podés coordinar para retirar tu pedido personalmente en Malvín. Te asesoramos si lo necesitás.'
  }, {
    icon: <Shield className="w-10 h-10 text-alphaGold" data-id="element-56" />,
    title: 'Productos Originales',
    desc: 'Solo vendemos suplementos 100% originales. Tu salud y tus resultados son nuestra prioridad.'
  }];
  return <section className="bg-gradient-to-b from-dark-900 via-dark-700 to-dark-900 py-[80px] px-5" data-id="element-57">
      <div className="max-w-[1100px] mx-auto" data-id="element-58">
        <h2 className="text-[2.2rem] font-black text-center mb-2.5 uppercase tracking-[2px] text-white" data-id="element-59">
          ¿Por Qué Elegirnos?
        </h2>
        <p className="text-center text-[#aaa] mb-[50px] text-[1.05rem]" data-id="element-60">
          No somos otra tienda más. Somos tu aliado en el camino al físico que
          querés.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-61">
          {benefits.map((b, i) => <div key={i} className="flex flex-col items-center text-center p-[35px_20px] bg-dark-600 border border-[#252525] rounded-md transition-colors duration-300 hover:border-alphaGold" data-id="element-62">
              <div className="mb-[15px]" data-id="element-63">{b.icon}</div>
              <h3 className="text-[1rem] font-extrabold uppercase tracking-[1px] mb-2.5 text-white" data-id="element-64">
                {b.title}
              </h3>
              <p className="text-[#888] text-[0.88rem] leading-[1.6]" data-id="element-65">
                {b.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}